<template>
  <div class="caseShare-container" v-if="showModel">
    <header class="mycase-header">
      <van-nav-bar
          :title="activityTittle"
          safe-area-inset-top
      >
      </van-nav-bar>
    </header>
    <article class="case-details" v-if="loadingCase">
      <van-sticky>
        <van-skeleton title avatar :row="3" v-if="showSkeleton"></van-skeleton>
        <div v-else class="card-box-cls">
          <div class="card-box">
            <div class="card-info" @click="handleViewUserCard">
              <div class="card-left">
                <img
                    :src="
                    oneCase.userCard.headImgUrl
                      ? `${imgUrl}/${oneCase.userCard.headImgUrl}`
                      : morenHeadImg
                  "
                    alt=""
                />
                <!-- <img src="../../assets/icons/mimi.jpg" alt=""> -->
                <div class="creater-info">
                  <div class="title">{{ oneCase.userCard.name }}</div>
                  <div class="second">
                    {{ oneCase.userCard.impressionLabel }}
                  </div>
                </div>
              </div>
              <div class="card-right" @click.stop="handleCall">
                <!-- <svg class="phone">
                    <use xlink:href="/phone.svg#phone-contract"></use>
                    </svg> -->
                <div class="phone">电话联系</div>
              </div>
            </div>
            <div class="synopsis">
              <span>{{ isFold ? foldSynopsisStr : synopsisStr }}</span>
              <span
                  style="color: #999"
                  @click="handleIsFold"
                  v-if="synopsisStr.length > 40"
              >{{ isFold ? "...展开" : "&lt;&lt;折叠" }}</span
              >
            </div>
          </div>
        </div>
      </van-sticky>
<!--      <div class="case-design">-->
<!--        <p>设计理念</p>-->
<!--        <div class="decribe-text">-->
<!--          {{ oneCase.idea }}-->
<!--        </div>-->
<!--        <div class="case-content">-->
<!--          <div class="case-content-box">-->
<!--            <transform-html :contents="oneCase.picDescription"></transform-html>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div v-for="it in activityFileList" :key="it.fileId">
        <video v-if="it.type=='.mp4'" controls :src="it.url"  :poster="VUE_APP_WATCH_FILE_API + '/' + it.coverUrl" style="width: 100%">
        </video>
        <img v-else :src="it.url" style="display: block;width: 100%" @click="handleShowForm(it)">
      </div>
    </article>
    <footer class="huoke-footer">
      <div class="article_list_buttom2">
        <van-tabbar v-model="active" active-color="#646566" @change="onChange">
          <van-tabbar-item>
            <icon-svg iconClass="iconsmartphone1" class="zixun" />
            <span>电话联系</span>
          </van-tabbar-item>
          <van-tabbar-item>
            <icon-svg iconClass="iconmessage-square" class="zixun" />
            <span>我要咨询</span>
          </van-tabbar-item>
        </van-tabbar>
      </div>
    </footer>
<!--    点击图片弹出框-->
    <van-overlay :show="showEditForm" @click="showEditForm = false">
      <div class="form-wrapper" @click.stop>
        <div class="form" >
          <img src="../../assets/images/activity_write_form.png">
          <div class="form-body">
            <div class="form-item" v-for="it in activityFormList" :key="it.formId">
              <span class="label">{{ it.formName+":" }}</span>
              <div class="padding-left">
                <van-field v-if="it.formTypeId===1" v-model="it.selectValue" label="" placeholder="请输入" />
                <span v-if="it.formTypeId===2" style="color: #289fff;margin-top: 5px" @click="selectTime(it)">{{it.selectValue?it.selectValue:"请选择时间"}}</span>
                <van-radio-group v-if="it.formTypeId===3&&!it.hasMultiple" v-model="it.selectValue" direction="horizontal">
                  <van-radio v-for="(item,index) in it.formValue" :key="index" :name="item" icon-size="18px">{{ item }}</van-radio>
                </van-radio-group>
                <van-checkbox-group v-if="it.formTypeId===3&&it.hasMultiple" v-model="it.selectValue" direction="horizontal">
                  <van-checkbox v-for="(item,index) in it.formValue" :key="index" :name="item" shape="square" icon-size="18px">
                    {{ item }}</van-checkbox>
                </van-checkbox-group>
              </div>
            </div>
            <div class="button-size">
              <van-button type="primary" size="large" @click="submitForm">提交</van-button>
            </div>
          </div>
          <van-icon name="close" style="color: #FFFFFF;font-size: 26px;margin-top: 24px" @click="closeForm"/>
        </div>
      </div>
    </van-overlay>

<!--    <van-popup v-model:show="showTime" position="bottom" :style="{ height: '50%',borderTopLeftRadius:'12px',borderTopRightRadius:'12px' }" >-->
<!--      <van-datetime-picker-->
<!--          @cancel="showTime = false"-->
<!--          @confirm="confirmSelectTime"-->
<!--          v-model="currentDate"-->
<!--          type="date"-->
<!--          title="选择日期"-->
<!--      />-->
<!--    </van-popup>-->
    <van-calendar v-model:show="showTime" @confirm="confirmSelectTime" :min-date="minDate" :max-date="maxDate" color="#1989fa"/>
    <!-- 咨询 -->
    <div class="consulting">
      <van-overlay :show="showConsulting" @click="showConsulting = false">
        <div class="wrapper" @click.stop>
          <div class="block">
            <p class="title">我要咨询</p>
            <van-form ref="addInfoForm" error-message-align="right">
              <div class="info">
                <van-field
                    v-model="addInfo.username"
                    label="姓名"
                    :rules="[{ required: true, message: '请输入名称' }]"
                />
                <van-field
                    v-model="addInfo.phone"
                    label="手机号"
                    type="tel"
                    :rules="[
                    {
                      required: true,
                      pattern: /^1[3|4|5|7|8]\d{9}$/,
                      message: '无效手机号',
                    },
                  ]"
                />
                <van-field
                    v-model="addInfo.content"
                    label="留言"
                    type="textarea"
                    :rules="[{ required: true, message: '请输入留言' }]"
                />
              </div>
            </van-form>
            <van-grid clickable :column-num="2">
              <van-grid-item text="返回" @click="handlecomback" />
              <van-grid-item text="保存" @click="handleAddInfo" />
            </van-grid>
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, toRefs, onUnmounted, ref } from "vue";
import { Dialog, Toast } from "vant";
import { useRoute, useRouter } from "vue-router";
import { createCaseConsult } from "../../api/case";
// import { addNum} from "../../api/buildSite";
import {addClueBehaviorInfo} from "@/api/user/clue"
import { useWxAuthorization } from "@/hooks/wxAuthorization";
// import transformHtml from "../../components/transformHTML.vue";
import {findActivityApp,activityAddNum,createActivityFormMsgApp} from "../../api/activity"
import $ from "jquery";
import { initWechatShare } from "../../hooks/initWechatShare";
import {addClue} from "../../api/user/clue";
export default {
  components: {
    // transformHtml,
  },
  setup() {
    let internal = null;
    let seconds = 0;
    const route = useRoute();
    const router = useRouter();
    let addInfoForm = ref(null);
    const merchantId = route.params.merchantId;
    const recommendClueId = route.params.recommendClueId?route.params.recommendClueId:''
    const state = reactive({
      activityTittle:'',
      minDate: new Date(1990, 0, 1),
      maxDate: new Date(2030, 0, 31),
      showTime:false,
      currentDate:'',
      checkList:[],
      radio:null,
      value:"",
      activityFormList:[],
      showEditForm:false,
      activityFileList:[],
      showSkeleton:true,
      showModel: true,
      panoramicUrl: "",
      morenImg: require("../../assets/images/activity_default_img.jpg"),
      morenHeadImg: require("../../assets/icons/Vector.png"),
      active: null,
      showConsulting: false,
      loading: false,
      imgUrl: process.env.VUE_APP_WATCH_FILE_API,
      loadingCase: false,
      showShare: false,
      activityId: route.params.id,
      consultId: null,
      openId: null,
      oneCase: {},
      icon: {
        inactive: require("../../assets/icons/smartphone.png"),
        active: require("../../assets/icons/smartphone.png"),
        mycaseN: require("../../assets/icons/wechat-chat.png"),
        mycaseC: require("../../assets/icons/wechat-chat.png"),
        consult: require("../../assets/icons/message-square.png"),
      },
      addInfo: {
        username: "",
        phone: "",
        content: "",
        busiId: route.params.id,
      },
      synopsisStr: "",
      foldSynopsisStr: "",
      isFold: true,
      clueId: "",
      VUE_APP_WATCH_FILE_API:process.env.VUE_APP_WATCH_FILE_API
    });
    const closeForm = ()=>{
      state.showEditForm = false
      // state.showConsulting = false
      state.active = null;
    }
    const formatDate = (date) => `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    const confirmSelectTime = (value)=>{
      // console.log('选择的时间',value)
      state.activityFormList.map(it=>{
        if (it===state.choiceItem){
          it.selectValue = formatDate(value)
        }
      })
      state.showTime = false
    }
    const submitForm=()=>{
      let obj = state.activityFormList.map(it=>{
        return {formName:it.formName,formMsg:it.selectValue.toString()}
      })
      console.log("保存参数=========",obj)

      let p = {
        activityId: state.activityId,
        list:obj,
        clueId:state.clueId
      }
      createActivityFormMsgApp(p).then(res=>{
        if (res){
          state.consultId = res
          state.showEditForm = false
          state.active = null;
          Toast.success('已提交！')
          loadCaseDetails()
          countUserAction({clueId:state.clueId,openId:state.openId,type:10})
        }
      })
    }
    const selectTime = (it)=>{
      state.showTime = true
      state.choiceItem = it
    }
    const handleShowForm = (it)=>{
      if (it.hasRelation){
        state.showEditForm = true
      }
      console.log("点击的文件===========",it)
    }
    const onChange = (index) => {
      // console.log("标志号",index);
      if (index === 0) {
        handleCall();
        state.active = null;
      }
      if (index === 1) {
        // state.showConsulting = true;
        state.showEditForm = true
      }
    };
    const handlecomback = () => {
      state.showConsulting = false;
      state.active = null;
      state.addInfo.content = "";
    };
    const handleAddInfo = () => {
      state.active = null;
      let param = {
        ...state.addInfo,
      };
      addInfoForm.value.validate().then(() => {
        createCaseConsult(param).then((data) => {
          if (data) {
            state.consultId = data.id;
            // Dialog.alert({ title: "成功", message: "您的咨询已创建" });
            Toast.success("您的咨询已创建");
            countUserAction({clueId:state.clueId,openId:state.openId,type:5})
            state.showConsulting = false;
          }
        });
      });
    };
    const loadCaseDetails = async () => {
      let result = await findActivityApp(state.activityId);
      // document.getElementsByTagName("title")[0].innerText = result.title
      state.activityTittle = result.title
      state.oneCase = result;
      state.loadingCase = true;
      state.synopsisStr = result.userCard.selfIntro?result.userCard.selfIntro:'我坚信细节决定品质，专业决定价值！如有需求，请随时与我联系！';
      state.foldSynopsisStr = state.synopsisStr.substring(0, 44);
      state.panoramicUrl = result.panoramicUrl;
      state.showSkeleton = false
      // console.log("案例详情", result);
      state.activityFileList = result.activityFileList
      state.activityFormList = result.activityFormList
      state.activityFormList.map(it=>{
        if (it.hasMultiple){
          it.selectValue = []
        }else {
          it.selectValue = ''
        }
        if (it.formTypeId===3){
          // it.formName = it.formName.split(',')
          it.formValue = it.formValue.split(',')
        }
      })
      console.log("转换完成---------------",state.activityFormList)
    };
    //展开折叠
    //展开折叠
    const handleIsFold = () => {
      state.isFold = !state.isFold;
    };
    const useWxAuth = async ()=>{
      let data= await  useWxAuthorization()
      if (data) {
        state.openId = data.openId;
      } else {
        state.openId = route.query.openId;
      }
      // await loadCaseDetails();

      if (state.openId) {
        await loadCaseDetails();
        await handleFirstAddClue()
        let temp = location.href.split("?")[0];
        if(recommendClueId){
          temp =temp.replace(recommendClueId,state.clueId)
        }else {
          temp = `${temp}/${state.clueId}`
        }
        countUserAction({clueId:state.clueId,openId:state.openId,type:1})
        let shareImg;
        if (state.oneCase.smallCoverPic) {
          shareImg = `${process.env.VUE_APP_WATCH_FILE_API}/${state.oneCase.smallCoverPic}`;
        } else {
          shareImg = "https://wca.ujiaku.com/upload/wx/activity_default_img.jpg";
        }

        // eslint-disable-next-line no-undef
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            // eslint-disable-next-line no-undef
            wx.miniProgram.postMessage({
              data: {
                title: state.oneCase.title,
                img: shareImg,
                openId: state.openId,
                clueId: state.clueId,
                shareUrl:temp,
                type: 4
              },
            });
          } else {
            let title = state.oneCase.title;
            let desc = state.oneCase.title;
            let appPhone;
            if (localStorage.getItem("appPhone")) {
              appPhone = localStorage.getItem("appPhone")
            } else {
              appPhone = route.query.appPhone
            }
            let url = `${
                    process.env.VUE_APP_WECHAT_SHARE
            }/shareForward?shareUrl=${temp}?appPhone=${appPhone}`;
            let imgUrl = shareImg;
            initWechatShare({ title, desc, url, imgUrl,openId:state.openId,clueId:state.clueId,type:4 });
          }
        });
      }
    }
    // useWxAuthorization().then((data) => {
    //   if (data) {
    //     state.openId = data.openId;
    //   } else {
    //     state.openId = route.query.openId;
    //   }
    //   if (state.openId) {
    //     handleFirstAddClue().then(()=>{
    //       countUserAction({clueId:state.clueId,openId:state.openId,type:1})
    //     })
    //   }
    // });
    //电话
    const handleCall = () => {
      if (state.oneCase.userCard.contactNum) {
        let a = document.createElement("a");
        a.setAttribute("href", `tel:${state.oneCase.userCard.contactNum}`);
        a.click();
        countUserAction({clueId:state.clueId,openId:state.openId,type:2})
      } else {
        Dialog.alert({ title: "错误", message: "没有电话号码" });
      }
    };
    const handleFirstAddClue = async () => {
      let miniProgramPhone = route.query.state
          ? route.query.state
          : route.query.miniProgramPhone;
      let param = {
        shareId: state.activityId,
        clueSource: 10,
        browseSecond: 0,
        beSharePhone: miniProgramPhone,
        openId: state.openId,
        title: state.oneCase.title,
        createId: state.oneCase.loginUserId,
        consultId: state.consultId,
        clueShareSource: route.params.clueShareSource,
        recommend_Clue_Id:recommendClueId,
        merchantId
      };
      let data = await addClue(param);
      state.clueId = data;
      return data;
    };
    const handleViewUserCard = () => {
      let miniProgramPhone = route.query.state
          ? route.query.state
          : route.query.miniProgramPhone;
      router.push({
        path: `/wxShareUserCard/${route.params.clueShareSource}/${merchantId}/${recommendClueId}`,
        query: { miniProgramPhone: miniProgramPhone, openId: state.openId },
      });
    };
    const handleAddClue = () => {
      if (seconds > 0) {
        let miniProgramPhone = route.query.state
            ? route.query.state
            : route.query.miniProgramPhone;
        let param = {
          clueId: state.clueId,
          browseSecond: seconds,
          consultId: state.consultId,
          shareId: state.activityId,
          clueSource: 10,
          beSharePhone: miniProgramPhone,
          openId: state.openId,
          title: state.oneCase.title,
          createId: state.oneCase.loginUserId,
          clueShareSource: route.params.clueShareSource,
          recommend_Clue_Id:recommendClueId,
          merchantId
        };
        $.ajax({
          async: false,
          url: `${process.env.VUE_APP_BASE_API}/user/clue/addClue`,
          type: "post",
          contentType: "application/json;charset=UTF-8",
          data: JSON.stringify(param),
        });
        seconds = 0;
        clearInterval(internal);
      }
    };
    const handleWindowHide = () => {
      if (seconds > 0) {
        let miniProgramPhone = route.query.state
            ? route.query.state
            : route.query.miniProgramPhone;
        let param = {
          clueId: state.clueId,
          browseSecond: seconds,
          consultId: state.consultId,
          shareId: state.activityId,
          clueSource: 10,
          beSharePhone: miniProgramPhone,
          openId: state.openId,
          title: state.oneCase.title,
          createId: state.oneCase.loginUserId,
          clueShareSource: route.params.clueShareSource,
          recommend_Clue_Id:recommendClueId,
          merchantId
        };
        let blob = new Blob([JSON.stringify(param)], {
          type: "application/json",
        });
        navigator.sendBeacon(
            `${process.env.VUE_APP_BASE_API}/user/clue/addClue`,
            blob
        );
        seconds = 0;
        clearInterval(internal);
      }
    };
    const handleVisibilityStateChange = () => {
      if (document.visibilityState === "hidden") {
        handleAddClue();
        clearInterval(internal);
        seconds = 0;
      }
    };
    const countUserAction = async ({ clueId, openId, type }) => {
      /**
       * type:
       *  1查看
       *  2拨打
       *  3保存
       *  4转发
       *  5提交咨询
       *  6点赞
       *  7收藏
       *  8留言
       */

      if (clueId) {
        await addClueBehaviorInfo({ clueId, openId, type });
      }
    };
    onMounted(() => {
      activityAddNum(route.params.id, "views");
      // loadHotArticle();
      internal = setInterval(() => {
        seconds++;
      }, 1000);
      document.addEventListener(
          "visibilitychange",
          handleVisibilityStateChange
      );
      window.addEventListener("pagehide", handleWindowHide, false);
    });
    onUnmounted(() => {
      clearInterval(internal);
      handleAddClue();
      document.removeEventListener(
          "visibilitychange",
          handleVisibilityStateChange
      );
      window.removeEventListener("pagehide", handleWindowHide, false);
    });
    //全景图返回
    const overallViewComback = () => {
      state.showModel = !state.showModel;
    };
    useWxAuth()
    return {
      closeForm,
      ...toRefs(state),
      overallViewComback,
      handleIsFold,
      addInfoForm,
      onChange,
      handlecomback,
      handleAddInfo,
      handleCall,
      handleViewUserCard,
      handleShowForm,
      submitForm,
      selectTime,
      confirmSelectTime,
      formatDate,
    };
  },
};
</script>
<style lang="scss">
.panoramic-containei {
  position: relative;
  ::-webkit-scrollbar {
    display: none;
  }
  .comback-box {
    position: absolute;
    height: 36px;
    width: 60px;
    line-height: 36px;
    text-align: center;
    left: 0;
    top: 100px;
    color: white;
    font-size: 14px;
    background: rgba(46, 46, 46, 0.5);
    border-radius: 0 20px 20px 0;
    opacity: 0.5;
  }
}
.caseShare-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .form-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .form {
      width: 287px;
      height: 407px;
      border-radius: 16px;
      background-color: #fff;
      .van-button--large{
        height: 42px;
      }
      .button-size{
        margin: 10px auto;
        height: 42px;
        width: 240px;
        border-radius: 8px;
      }
      .form-body{
        position: relative;
        overflow-x: hidden;
        height:280px ;
        .form-item{
          width: 232px;
          min-height: 42px;
          border: 1px solid #BFBFBF;
          border-radius: 4px;
          margin:0 auto;
          margin-bottom: 10px;
          padding:0 5px;
          //padding-top: 12px;
          font-size: 14px;
          display: flex;
          .van-field{
            padding: 0;
            //padding-top: 12px;
          }
          .van-radio{
            margin-bottom: 4px;
          }
          .van-checkbox__label{
            margin-bottom: 4px;
          }
          .label{
            color: #999999;
            flex-shrink: 0;
            //line-height: 42px;
            text-align: right;
            display: block;
            padding-top: 12px;
            width: 80px;
          }
          .padding-left{
            padding-left: 5px;
            padding-top: 12px;
          }
        }
      }
      >img{
       display: block;
        width: 100%;
        margin-bottom: 10px;
      }

    }
  }
  .case-details {
    flex: 1;
    overflow-x: hidden;
    color: rgba(0, 0, 0, 0.56);
    .card-box-cls {
      //background-color: #fff;
      padding: 5px 16px 16px 16px;
    }
    .card-box {
      // margin: 5px 16px 16px 16px;
      padding: 12px;
      border-radius: 8px;
      text-align: left;
      background-color: #fff;
      box-shadow: 0px 0px 15px rgb(229, 229, 230);
      .synopsis {
        margin-top: 5px;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.84);
      }
      .card-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .card-left {
          display: flex;
          img {
            height: 40px;
            width: 40px;
            object-fit: cover;
            border-radius: 20px;
          }
          .creater-info {
            margin-left: 8px;
            .title {
              font-weight: bold;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.84);
              margin-bottom: 3px;
            }
            .second {
              font-weight: normal;
              font-size: 11px;
              color: rgba(0, 0, 0, 0.4);
            }
          }
        }
        .card-right {
          .phone {
            width: 80px;
            height: 30px;
            background-color: #289fff;
            font-size: 12px;
            color: white;
            text-align: center;
            line-height: 30px;
            border-radius: 5px;
          }
        }
      }
    }
    .case-base-info {
      padding: 0 16px;
      border-bottom: 1px solid #f7f7f7;
      .case-namecard {
        //  border: 1px solid #cccccc;
        border-radius: 8px;
        box-shadow: 0 0 6px 6px #f7f7f7;
        .img-name {
          height: 40px;
          padding: 5px 16px;
          img {
            display: block;
            height: 40px;
            width: 40px;
            border-radius: 20px;
            float: left;
          }
          .creater-info {
            float: left;
            margin-left: 10px;
            font-size: 14px;
            text-align: left;
            p {
              margin: 0;
            }
            > p:nth-child(1) {
              font-weight: bold;
            }
            > p:nth-child(2) {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.4);
            }
          }
        }
        .create-describe {
          font-size: 12px;
          text-align: left;
          padding: 5px 16px;
        }
      }
      .mycase-box-info {
        flex: 1;
        padding: 5px 0;
        .case-box {
          font-size: 16px;
          text-align: left;
          .cover-img {
            height: 160px;
            position: relative;
            .house-tour {
              position: absolute;
              top: 50%;
              left: 50%;
              color: #fff;
              transform: translate(-50%, -50%);
              background: rgba(31, 30, 30, 0.5);
              opacity: 0.8;
              height: 20px;
              border-radius: 20px;
              font-size: 14px;
              padding: 8px 30px;
            }
            > img {
              display: block;
              border-radius: 4px;
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }
          .case-info {
            //  height: auto;
            position: relative;
            display: flex;
            width: 343px;
            justify-content: space-between;
            .title {
              //  float: left;
              position: relative;
              width: 330px;
              > p {
                margin: 0;
                padding: 0;
              }
              > p:nth-child(1) {
                font-weight: 700;
                margin-top: 8px;
                color: #333333;
              }
              > p:nth-child(2) {
                font-weight: 400;
                font-size: 14px;
                margin: 4px 0;
                color: #666666;
              }
            }
            .share-del {
              top: 10px;
              position: relative;
              .share {
                height: 20px;
                width: 20px;
                background: url("../../assets/icons/share-3.png") no-repeat;
              }
              .del {
                height: 20px;
                margin-top: 15px;
                width: 20px;
                background: url("../../assets/icons/trash-2.png") no-repeat;
              }
            }
          }
        }
      }
    }
    .case-design {
      padding: 5px 16px;
      padding-bottom: 0;
      text-align: left;
      p {
        margin: 0;
        margin-top: 10px;
        margin-bottom: 5px;
        font-size: 18px;
        font-weight: bold;
      }
      .decribe-text {
        color: #666;
        font-size: 12px;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .case-content {
        width: 100%;
        font-size: 14px;
        text-align: left;
        box-sizing: border-box;
        background-color: #ffffff;
        .case-content-box {
          // height: 300px;
          // background-color: deeppink;
          p {
            margin: 0;
            padding: 0;
            font-size: 14px;
            font-weight: 400;
          }
          border-bottom: 1px solid #f1f3f6;
        }
      }
      .case-design-details {
        .cover-img {
          height: 160px;
          > img {
            display: block;
            border-radius: 4px;
            height: 100%;
            width: 100%;
            object-fit: cover;
          }
        }
        > span {
          color: #666;
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
    .case-content {
      width: 100%;
      font-size: 14px;
      text-align: left;
      box-sizing: border-box;
      background-color: #ffffff;
      .case-content-box {
        p {
          margin: 0;
          padding: 0;
          font-size: 14px;
          font-weight: 400;
        }
        border-bottom: 1px solid #f1f3f6;
      }
    }
  }
  .huoke-footer {
    position: relative;
    height: 50px;
    .add_article {
      height: 36px;
      width: 52px;
      color: #fff;
      line-height: 36px;
      border-radius: 8px;
      font-size: 28px;
      position: fixed;
      z-index: 2;
      left: 50%;
      bottom: 7px;
      transform: translateX(-50%);
      background-color: #ff6e01;
    }
    .van-tabbar-item__text {
      display: flex;
      flex-direction: column;
      align-items: center;
      .zixun {
        display: block;
        margin-bottom: 3px;
        font-size: 22px;
      }
    }
  }
  //遮罩层
  .consulting {
    font-size: 14px;
    font-weight: bold;
    color: #0000;

    .van-field__label {
      width: 44px;
    }

    .van-field__control {
      font-weight: 500;
      width: 194px;
      border: 1px solid #bfbfbf;
      border-radius: 5px;
    }

    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .block {
      width: 303px;
      border-radius: 8px;
      background-color: #fff;
      color: black;

      > div {
        // height: 20px;
        > div:nth-child(1) {
          .van-hairline {
            border-radius: 0 0 0 10px;
            padding: 0;

            height: 46px;

            .van-grid-item__text {
              color: #999999;
            }
          }
        }

        > div:nth-child(2) {
          .van-hairline {
            border-radius: 0 0 10px 0;
            padding: 0;

            .van-grid-item__text {
              color: #333333;
            }
          }

          [class*="van-hairline"]::after {
            border-right: none;
          }
        }
      }

      [class*="van-hairline"]::after {
        border-bottom: none;
      }

      .name-card {
        background-color: #ffff;
        border-bottom: 1px solid #f1f3f6;
        padding: 0 16px;

        p {
          padding: 0;
          margin: 0;
        }

        .name-info {
          display: flex;
          text-align: left;
          font-size: 14px;
          color: #333333;
          padding: 8px 0;
          // justify-content: space-between;
          img {
            height: 40px;
            width: 40px;
            border-radius: 20px;
          }

          .creater-info {
            margin-left: 8px;

            > p:nth-child(1) {
              font-weight: 700;
            }

            > p:nth-child(2) {
              font-size: 12px;
              color: #666666;
            }
          }
        }

        .synopsis {
          text-align: left;
          font-size: 12px;
          color: black;
        }
      }

      .info {
        padding: 0 10px;

        .van-cell::after {
          border: none;
        }

        .van-field__label {
          color: black;
        }

        [class*="van-hairline"]::after {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
